<template>
    <v-dialog
    v-model="dialog"
    @click:outside="closeDialog"
    max-width="1400px"
    scrollable
    z-index="210"
  >
        <v-card >
            <v-toolbar dense :elevation="0">
                <v-toolbar-title class="text-primary-700">Scrape Information for {{ entity.name }} <template v-if="entity.last_parsed_at">on {{ entity.last_parsed_at }}</template></v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn style="width: 35px; height: 35px" icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-8 pt-6">
                <v-row v-if="!loading">
                    <v-row class="ma-0 pb-2" align="center">
                        <v-checkbox v-model="hideWithDetails" hide-details label="Hide Links with Store Details" class="mt-0 pt-0"></v-checkbox>
                        <v-checkbox v-model="onlyErrors" hide-details label="Show Only Links with Errors" class="ml-4 mt-0 pt-0"></v-checkbox>
                        <v-spacer></v-spacer>
                        <div >
                            <v-text-field v-model="search" dense hide-details label="Search" outlined append-icon="mdi-magnify" clearable></v-text-field>
                        </div>
                    </v-row>
                    
                    <v-data-table
                        style="width: 100%; border: 1px solid #e0e0e0; border-radius: 4px; "
                        :headers="headers"
                        :search="search"
                        :items="filteredData"
                        :custom-sort="sortData"
                        disable-pagination
                        :items-per-page="-1" 
                        fixed-header
                    >
                        <template v-slot:body="{ items }">
                            <tbody v-if="items.length > 0">
                                <tr v-for="item in items" :key="item.id" class="data-table__row">
                                     
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.address }}</td>
                                    <td><a :href="item.link" target="_blank" style="text-decoration: none;">{{ item.link }}</a></td>
                                    <td>{{ item.parsed_at }}</td>
                                    <td>{{ item.existed_at }}</td>
                                    <td style="max-width: 400px;">
                                        <span class="clamp-2">{{ item.error }}</span>
                                        <!-- icon to edit error -->
                                        <v-tooltip left>
                                            <template v-slot:activator="{ on }">
                                                <span v-on="on">
                                                    <v-icon small @click="editError(item)" class="mx-1">mdi-pencil</v-icon>
                                                </span>
                                            </template>
                                            <span>Set Error</span>
                                            
                                        </v-tooltip>
                                    </td>
                                    <td class="text-center">
                                        <!-- action for resettting coords -->
                                         <v-tooltip left v-if="!compareCoords(item)">
                                            <template v-slot:activator="{ on }">
                                                <span v-on="on">
                                                    <v-icon color="primary" :disabled="compareCoords(item)" @click="resetCoords(item)" class="mx-1">mdi-refresh</v-icon>
                                                </span>
                                            </template>
                                            <span>Reset coordinates</span>
                                            <small v-if="compareCoords(item)"><br/>(Coordinates are already the same)</small>
                                        </v-tooltip>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td :colspan="headers.length" class="text-center">
                                        No links found
                                    </td>
                                </tr>
                            </tbody>
                        </template>

                    </v-data-table>
                </v-row>
                <v-row v-else>
                    <v-col cols="12" sm="6">
                        <v-skeleton-loader type="table-heading, paragraph, paragraph, paragraph, paragraph, paragraph, paragraph" :loading="loading" rows="10"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-skeleton-loader type="table-heading, paragraph, paragraph, paragraph, paragraph" :loading="loading" rows="6"></v-skeleton-loader>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-dialog v-model="editDialog" max-width="600px">
                <v-card>
                    <v-toolbar dense :elevation="0">
                        <v-toolbar-title class="text-primary-700">Set Error for {{ link.name }}</v-toolbar-title>
                        <div class="flex-grow-1"></div>
                        <v-btn style="width: 35px; height: 35px" icon @click="editDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-6">
                        <!-- multiselect with other -->
                         <v-radio-group class="mt-0" v-model="link.error" hide-details>
                            <v-radio class="mb-4" label="No Error" value=""></v-radio>
                            <v-radio class="mb-4" label="Duplicate Link" value="Duplicate Link"></v-radio>
                            <v-row class="mx-0 mt-0 mb-0" align="center">
                                <v-radio class="mb-0" value="Other"></v-radio><v-text-field class="mt-0" placeholder="Other" :disabled="link.error != 'Other'" hide-details v-model="editOther" dense></v-text-field>
                            </v-row>
                        </v-radio-group>
                        
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" depressed @click="saveError">Save</v-btn>
                        </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>        
    </v-dialog>
</template>
<script>

    
    export default {
        components: {

        },

        data: () => ({
            dialog: false,
            loading: true,
            data: [],
            search: '',
            hideWithDetails: false,
            onlyErrors: false,

            entity: {},
            editDialog: false,
            editOther: '',
            link: {},


            headers:[
                {text: 'Store Name', value: 'name',class:'data-table__cell'},
                {text: 'Address', value: 'address', class:'data-table'},
                {text: 'Link', value: 'link', class:'data-table__cell'},
                {text: 'Parsed At', value: 'parsed_at', class:'data-table__cell'},
                {text: 'Existed At', value: 'existed_at', class:'data-table__cell'},
                {text: 'Errors', value: 'error', class:'data-table__cell'},
                {text: 'Actions', value: 'actions', sortable: false}
            ]
        }),
        methods: {
            showDialog: function (item) {
                this.entity = item;
                this.getLinks(item.id);
                
                setTimeout(() => {
                    this.dialog = true;
                }, 100);
            },
            
            closeDialog: function () {
                this.loading = true;
                this.dialog = false;
            },

            editError(link) {
                // this.link = link;
                this.link = JSON.parse(JSON.stringify(link)); // deep copy to avoid mutating original object
                this.editOther = '';

                if (this.link.error && this.link.error !== 'Duplicate Link') {
                    this.editOther = this.link.error;
                    this.link.error = 'Other';
                }
                this.editDialog = true;
            },

            saveError() {
                if (this.link.error == 'Other' && this.editOther.trim() == '') {
                    this.$notify.error("Please enter a valid error message");
                    return;
                }
                this.$http.put(`/scrapers/links/${this.link.id}`, {
                    error: this.link.error == 'Other' ? this.editOther : this.link.error
                })
                .then(response => {
                    this.$notify.success("Error updated successfully")
                    this.editDialog = false;
                    this.getLinks(this.entity.id);
                })
                .catch(error => {
                    this.$notify.error("Error updating error, if this persists, please contact support")
                    console.log(error);
                });
            },

            getLinks: function (id) {
                this.$http.get('scrapers/all-links/',{
                    params: {
                        scraper_id: id
                    }
                })
                .then(response => {
                    this.data = response.data.data;

                    this.loading = false;
                })
                .catch(error => {
                    this.$notify.error("Error fetching links, if this persists, please contact support")
                    console.log(error);
                    this.loading = false;
                });
            },

            sortData(items, sortBy, sortDesc) {
                if (sortBy.length === 0) {
                    return items
                }

                return items.sort((a, b) => {
                    let sortA = a[sortBy[0]]
                    let sortB = b[sortBy[0]]
                    

                    if (typeof sortA === 'string') {
                        if((sortBy[0] == "last_parsed_at" || sortBy[0] == "verified_at")){                         
                            if (sortA) {
                                let dateA = sortA.split('/')
                                sortA = parseFloat(dateA[2] + dateA[1] + dateA[0])
                            } else {
                                if (sortDesc[0]) {
                                    sortA = 0
                                } else {
                                    sortA = 99999999
                                }
                            }
                            if (sortB) {
                                let dateB = sortB.split('/')
                                sortB = parseFloat(dateB[2] + dateB[1] + dateB[0])
                            } else {
                                if (sortDesc[0]) {
                                    sortB = 0
                                } else {
                                    sortB = 99999999
                                }
                            }
                            console.log(sortA, sortB)
                        }else{
                            return sortA.localeCompare(sortB) * (sortDesc[0] ? -1 : 1)
                        }

                    }

                    return (sortA - sortB) * (sortDesc[0] ? -1 : 1)
                })
                
            },

            compareCoords(item){
                // if item.lat and item.original_lat are not null or item.lng and item.original_lng are not null return true
                if (item.lat != null && item.lng != null && item.original_lat != null && item.original_lng != null) {
                    return (item.lat == item.original_lat  && item.lng == item.original_lng)
                } else {
                    return true
                }
            },

            resetCoords(item){
                this.$http.put(`/scrapers/links/${item.id}/position`, {
                    lat: item.original_lat,
                    lng: item.original_lng
                })
                .then(response => {
                    this.$notify.success("Coordinates reset successfully")
                    this.getLinks(this.entity.id);
                })
                .catch(error => {
                    this.$notify.error("Error resetting coordinates, if this persists, please contact support")
                    console.log(error);
                });
            }
            
        },

        computed:{
            filteredData: function () {
                let data = this.data;
                if (this.hideWithDetails) {
                    data = data.filter(item => (item.lat == null || item.lng == null) || item.error != null || item.parsed_at == null);
                }
                if (this.onlyErrors) {
                    data = data.filter(item => item.error != null);
                }
                if(!data){
                    return [];
                }
                return data;
            }
        },

        watch: {
            hideWithDetails: function (val) {
                // this.getLinks(this.entity.id);
            }
        }
    }

</script>
<style>
</style>